import { render, staticRenderFns } from "./LottoIcon.vue?vue&type=template&id=3c373763&"
import script from "./LottoIcon.vue?vue&type=script&lang=js&"
export * from "./LottoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports